export default "__VITE_ASSET__BTo4690U__"